/** Encabezado por defecto de la sección. */
export const DEFAULT_HEADING = 'También te puede interesar'

/**
 * Tarjetas visibles de partida y tamaño de cada tanda que revela «Ver más»:
 * 4 = dos filas completas de la rejilla, que es de 2 columnas tanto en
 * mobile/tablet (`VerticalCard`) como en desktop (`HorizontalCard`), así que el
 * recorte cae en un límite de fila en todos los anchos.
 */
export const ITEMS_PER_PAGE = 4

/** Texto fijo del botón que revela la siguiente tanda. */
export const LABEL_MORE = 'Ver más'

/**
 * Analítica (`components-fingerprint/Grid relacionados.csv`) — `view_item_list`
 * al entrar el módulo en viewport y `select_item` al clicar una card, más el
 * `click` de tarjeta genérico (mismo criterio que `Grid Cards.csv`/
 * `Grid destacados.csv`, módulos transversales).
 */
export const SIMILAR_ITEM_LIST_ID = 'pdp_eventos_relacionados'
export const SIMILAR_ITEM_LIST_NAME = 'eventos_relacionados'
export const SIMILAR_MODULE_NAME = 'representaciones_asociadas'
export const SIMILAR_MODULE_TYPE = 'product_list_related'

/**
 * `module_position` del `view_item_list` de este listado.
 *
 * ⚠️ PROVISIONAL — pendiente de Analítica. Ni el CSV ni el diccionario definen
 * cómo numerar `module_position` en una PDP compuesta a mano (no por
 * `ModulesAdminRenderer`, que sí numera sus módulos CMS por índice de array):
 * aquí se usa la posición de "También te puede interesar" en el orden real de
 * secciones de `PerformancePage.tsx` (hero, promo, buybox, about, gallery,
 * highlights, venue, reviews → 9ª sección).
 */
export const SIMILAR_MODULE_POSITION = '9'
